class SwiperManager {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }
    run() {
        document.querySelectorAll('[data-slideshow]').forEach((el) => {
            new SwiperItem(el)
        })
    }
}

class SwiperItem {
    constructor(el) {
        const dragSize = this.getDragSize()
        this.el = el
        this.swiper = new Swiper(this.el, {
            // direction: "vertical",
            // pagination: {
            //     el: ".swiper-pagination",
            //     clickable: true,
            // },
            allowTouchMove: false,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false
            },
            direction: "vertical",
            // mousewheel: {
            //     forceToAxis: true,
            //     sensitivity: 1,
            //     releaseOnEdges: true,
            // },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
                dragSize: dragSize
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
        })
    }

    getDragSize() {
        return 123
    }
}

export default SwiperManager